import { makeAutoObservable } from "mobx";
import { makePersistable } from 'mobx-persist-store';
import { postRequest } from "../lib/axios/ops-request";

export class AuthStore {
    /**
     *  State
     */
    // Form
    //username = '' as string;
    password = '' as string;
    username = '' as string;
    fullname = '' as string;
    phone_number = '' as string;
    // Change Password Form
    old_password = '' as string;
    new_password = '' as string;
    confirm_password = '' as string;
    loading = false as boolean;
    change_password_error = '' as string;
    // Auth Data
    // eslint-disable-next-line
    auth_data = null as any;
    // Other
    success_alert_register_toggle = false as boolean;
    success_alert_login_toggle = false as boolean;
    failed_alert_register_toggle = false as boolean;
    failed_alert_login_toggle = false as boolean;
    success_change_password_toggle = false as boolean;
    failed_change_password_toggle = false as boolean;

    /**
     *  Constructor
     */
    constructor() {
        makeAutoObservable(this)

        makePersistable(this, { name: 'AuthStore', properties: ['auth_data'], storage: window.localStorage });
    }

    /**
     *  Common Method
     */
    // Set Success Alert Register Toggle
    setSuccessAlertRegisterToggle(value: boolean) {
        this.success_alert_register_toggle = value;
    }
    // Set Failed Alert Register Toggle
    setFailedAlertRegisterToggle(value: boolean) {
        this.failed_alert_register_toggle = value;
    }
    // Set Success Alert Login Toggle
    setSuccessAlertLoginToggle(value: boolean) {
        this.success_alert_login_toggle = value;
    }
    // Set Failed Alert Login Toggle
    setFailedAlertLoginToggle(value: boolean) {
        this.failed_alert_login_toggle = value;
    }
    // Set Success Change Password Toggle
    setSuccessChangePasswordToggle(value: boolean) {
        this.success_change_password_toggle = value;
    }
    // Set Failed Change Password Toggle
    setFailedChangePasswordToggle(value: boolean) {
        this.failed_change_password_toggle = value;
    }
    // Reset Change Password Form
    resetChangePasswordForm() {
        this.old_password = '';
        this.new_password = '';
        this.confirm_password = '';
        this.change_password_error = '';
    }
    // Check Auth
    checkAuth() {
        console.log(this.auth_data);
        if(this.auth_data && this.auth_data.access_token && this.auth_data.access_token !== null) {
            return;
        }else{
            window.location.href = '/login';
        }
    }
    // Logout
    logout() {
        window.location.href = '/login';
        setTimeout(() => {
            this.auth_data = null;
        }, 3000);
    }

    /**
     *  Request Method
     */
    async registerUser() {
        const response = await postRequest('/authentication/register', {}, {
            //username: this.username,
            password: this.password,
            email: this.username,
            fullname: this.fullname,
            phone_number: this.phone_number
        });

        if(response.data !== undefined) {
            this.success_alert_register_toggle = true;
        }else{
            this.failed_alert_register_toggle = true;
        }
    }
    async loginUser() {
        const response = await postRequest('/authentication/login-username', {}, {
            username: this.username,
            password: this.password
        });

        if(response.data !== undefined) {
            this.auth_data = response.data;
            this.success_alert_login_toggle = true;
            window.location.href = '/';
        }else{
            this.failed_alert_login_toggle = true;
        }
    }
    async changePassword() {
        // Validation
        if (!this.old_password || !this.new_password || !this.confirm_password) {
            this.change_password_error = 'Semua field harus diisi';
            this.failed_change_password_toggle = true;
            return;
        }

        if (this.new_password !== this.confirm_password) {
            this.change_password_error = 'Password baru dan konfirmasi tidak cocok';
            this.failed_change_password_toggle = true;
            return;
        }

        if (this.new_password.length < 6) {
            this.change_password_error = 'Password baru minimal 6 karakter';
            this.failed_change_password_toggle = true;
            return;
        }

        this.loading = true;
        this.change_password_error = '';

        try {
            const response = await postRequest('/authentication/change-password', {}, {
                userId: this.auth_data?.user?.id,
                oldPassword: this.old_password,
                newPassword: this.new_password
            });

            if(response.data !== undefined) {
                this.success_change_password_toggle = true;
                this.resetChangePasswordForm();
                // Redirect to home after successful change
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            } else {
                this.change_password_error = 'Gagal mengubah password';
                this.failed_change_password_toggle = true;
            }
        } catch (error: any) {
            this.change_password_error = error.response?.data?.message || 'Password lama tidak valid';
            this.failed_change_password_toggle = true;
        } finally {
            this.loading = false;
        }
    }
}

const authStore = new AuthStore();
export default authStore;